// extracted by mini-css-extract-plugin
module.exports = {"root":"app-403-components-403-root","title":"app-403-components-403-title","description":"app-403-components-403-description"};